import Layout from "@/admin/js/layout/index.vue";

const standaloneProjectsRoute = {
    name: 'all-projects',
    path: '/projects',
    component: Layout,
    redirect: '/projects/list',
    meta: { title: 'Проекты', noCache: false },

    children: [
        {
            name: 'projects-quick-start',
            path: 'quick-start',
            component: () => import('@/admin/js/views/projects/quick-start/index.vue'),
            meta: { title: 'Быстрый старт', noCache: true }
        },
        {
            name: 'projects-list',
            path: 'list',
            component: () => import('@/admin/js/views/projects/index'),
            meta: { title: 'Все проекты', noCache: true }
        },
        {
            name: 'project-detail',
            path: ':project_id',
            component: () => import('@/admin/js/views/projects/show'),
            meta: { title: '', noCache: true },
            children: [
                {
                    name: 'project-keys',
                    path: '',
                    component: () => import('@/admin/js/views/project-keys/index'),
                    meta: { title: ' ', noCache: true }
                }
            ]
        }
    ]
};

export default standaloneProjectsRoute;
